import * as React from 'react'
import { FC, useCallback } from 'react'
import { ENTITY_TYPES } from '@sales-center/common'
import { ActionModal } from '@sales-center/components'
import { useNoteFilterState } from '@user/components/Notes/EntityNotes/hooks/useNoteFilterState'
import { NoteFilters } from '@user/components/Notes/EntityNotes/NoteFilters'
import { SalesCenterNotes } from '@user/components/Notes/EntityNotes/SalesCenterNotes'
import { NoteDetailsProps } from '@user/components/Leads/LeadCard/NotesDrawer/typings'
import Stack from '@mui/material/Stack'
import { useSelector } from 'react-redux'
import {
  selectAllBillToLocations,
  selectAllServiceLocations,
} from '@user/store/entityLocations'
import { useTheme } from '@mui/material/styles'

interface Props {
  entityId: number
  entityType: ENTITY_TYPES
  onClose: () => void
  onNoteAdd: () => void
  open: boolean
  canUpdate?: boolean
  backToNotes?: boolean
  setBackToNotes?: (value: boolean, id: number) => void
  externalLocationId: string
  detail: NoteDetailsProps
  locationsStatus: 'pending' | 'success' | 'fail'
}

export const ViewNotesModal: FC<Props> = (props) => {
  const {
    entityType,
    onClose,
    onNoteAdd,
    open,
    externalLocationId,
    detail,
    canUpdate = false,
    backToNotes = false,
    setBackToNotes,
    locationsStatus,
  } = props
  const noteFilterState = useNoteFilterState()

  const serviceLocations = useSelector(selectAllServiceLocations)
  const billingLocations = useSelector(selectAllBillToLocations)
  const entityLocations = {
    billToLocations: billingLocations,
    serviceLocations,
  }

  const onAddNote = useCallback(() => {
    onClose()
    onNoteAdd()
  }, [onClose, onNoteAdd])
  const theme = useTheme()
  return (
    <ActionModal
      title={'Notes'}
      onClose={onClose}
      open={open}
      actionBtn={canUpdate}
      actionBtnLabel={'Add note'}
      ondAddNote={onAddNote}
      customContinerWidth={{
        xs: '90vw',
        md: '50vw',
      }}
    >
      <Stack
        pl={2}
        pt={0}
        pr={2}
        sx={{
          width: '100%',
          overflowY: 'auto',
          backgroundColor: theme.palette.background.default,
        }}
      >
        <NoteFilters
          externalLinkId={externalLocationId}
          {...noteFilterState}
          entityType={entityType}
        />
        <SalesCenterNotes
          canUpdate={canUpdate}
          entityType={entityType}
          showPestPacNote={noteFilterState.showPestPacNote}
          showKnockStatusNote={noteFilterState.showKnockStatusNote}
          sortBy={noteFilterState.sortBy}
          detail={{
            ...detail,
            locations: entityLocations,
          }}
          backToNotes={backToNotes}
          setBackToNotes={setBackToNotes}
          locationsStatus={locationsStatus}
        />
      </Stack>
    </ActionModal>
  )
}

ViewNotesModal.displayName = 'AddNoteDrawer'
